import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "omnibar-menu-button";
export var OMNIBAR_MENU_BUTTON_CONSTANTS = {
    elementName: elementName
};
